function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Icon from "../elements/icon";
var any = PropTypes.any,
    string = PropTypes.string,
    func = PropTypes.func,
    bool = PropTypes.bool;

var SearchBox = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchBox, _React$Component);

  var _super = _createSuper(SearchBox);

  function SearchBox() {
    var _this;

    _classCallCheck(this, SearchBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focus: false,
      has_value: false
    });

    _defineProperty(_assertThisInitialized(_this), "searchbox", null);

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      return _this.searchbox != null ? _this.searchbox.focus() : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdateHasValue", function () {
      if (_this.mounted) {
        return _this.setState({
          has_value: !!_this.searchbox.value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function (e) {
      var node = _this.searchbox;
      node.value = "";

      _this.handleUpdateHasValue();

      if (e) {
        _this.handleKeyUp(e);

        return _this.handleChange(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (e) {
      e.stopPropagation();

      _this.handleUpdateHasValue();

      return typeof _this.props.onKeyUp === "function" ? _this.props.onKeyUp(_this.searchbox.value, e) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      e.stopPropagation();

      _this.handleUpdateHasValue();

      return typeof _this.props.onChange === "function" ? _this.props.onChange(_this.searchbox.value, e) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCrossIconKeyUp", function (e) {
      if (e.key === "Tab") {
        _this.handleClear(e);

        _this.focus();
      }
    });

    return _this;
  }

  _createClass(SearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.defaultValue || this.searchbox.value) {
        this.setState({
          has_value: true
        });
      }

      if (this.props.focusOnMount) {
        this.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var node = this.searchbox;

      if (!(node != null ? node.value : undefined) && nextProps.defaultValue != null && nextProps.defaultValue !== this.props.defaultValue) {
        if (nextProps.defaultValue) {
          this.setState({
            has_value: true
          });
        }

        return node.value = nextProps.defaultValue;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var base_props = {
        className: classNames("et--search-box", this.props.className)
      };

      var safe_props = _.omit(this.props, ["className", "focusOnMount"]);

      var attrs = _.extend({}, base_props, safe_props);

      return /*#__PURE__*/React.createElement("span", attrs, /*#__PURE__*/React.createElement(Icon, {
        icon: "search",
        className: "et--search-box--search-icon"
      }), /*#__PURE__*/React.createElement("input", {
        type: "search",
        ref: function ref(e) {
          _this2.searchbox = e;
        },
        "data-testid": "search-box",
        className: "et--search-box--input",
        name: this.props.name,
        defaultValue: this.props.defaultValue,
        placeholder: this.props.placeholder,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        onKeyUp: this.handleKeyUp,
        onChange: this.handleChange,
        "aria-label": "Search box",
        disabled: this.props.disabled
      }), this.state.has_value ? /*#__PURE__*/React.createElement(Icon, {
        title: "clear",
        className: "et--search-box--clear",
        icon: "cancel",
        onClick: this.handleClear,
        isReachable: true,
        onKeyUp: this.handleCrossIconKeyUp
      }) : undefined);
    }
  }]);

  return SearchBox;
}(React.Component);

_defineProperty(SearchBox, "displayName", "SearchBox");

_defineProperty(SearchBox, "propTypes", {
  name: string,
  placeholder: string,
  defaultValue: any,
  hideSearchIcon: bool,
  onKeyUp: func,
  onChange: func,
  onFocus: func,
  onBlur: func,
  focusOnMount: bool,
  disabled: bool
});

export { SearchBox as default };